module.exports = __webpack_public_path__ + "img/7_202.733f2b95.png";